import a from"./global.js";import o from"./is-object.js";var m=a,t=o,e=m.document,n=t(e)&&t(e.createElement),c=function(r){return n?e.createElement(r):{}};export{c as default};
